"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./routing/defineRouting.js");exports.defineRouting=e.default;
